<!-- Header Section -->
<section class="header-section">
  <!-- Content + Overlay inside -->
  <div class="header-content">
    <!-- Navbar -->
    <!-- Social Bar Section -->
    <div class="social-bar">
      <div class="container px-4">
        <div class="row align-items-center">
          <div class="col-md-6 text-start contact-d">
            <a href="tel:7353311550"><i class="bi bi-telephone-fill"></i>73533 11550</a>
            <a href="mailto:admin@ftd.travel"><i class="bi bi-envelope-fill"></i>admin@ftd.travel</a>
          </div>
          <div class="col-md-6 text-end">
            <a href="#" class="social-icon"><i class="bi bi-facebook"></i></a>
            <a href="#" class="social-icon"><i class="bi bi-linkedin"></i></a>
            <a href="#" class="social-icon"><i class="bi bi-x"></i></a>
            <a href="#" class="social-icon"><i class="bi bi-youtube"></i></a>
            <a href="#" class="social-icon"><i class="bi bi-instagram"></i></a>
          </div>
        </div>
      </div>
    </div>
    <!-- End Of Social bar section -->
    <div class="container">


      <nav class="navbar navbar-expand-lg navbar-dark px-0 d-flex flex-column flex-lg-row align-items-lg-center justify-content-between">
        <!-- Logo -->
        <div class="w-100 text-center d-lg-flex justify-content-lg-start mb-2 mb-lg-0">
          <a class="navbar-brand d-flex align-items-center justify-content-center justify-content-lg-start mx-auto mx-lg-0"
             href="#">
            <img src="./assets/images/SRI/Logo/logo-main.png" class="me-2" alt="logo">
          </a>
        </div>

        <!-- Buttons and Dropdowns (horizontal line in mobile) -->
        <div class="nav-btns d-flex flex-nowrap  align-items-center w-100 px-3 px-lg-0 right-btn justify-content-end">
          <a class="btn text-light btn-sm abt-btn" routerLink="/aboutus">About Us</a>
          <a class="btn text-light btn-sm ctt-btn" routerLink="/Contactus">Contact Us</a>

          <!-- Currency Dropdown -->
          <div class="dropdown">
            <button class="btn text-light btn-sm dropdown-toggle" type="button" id="currencyDropdown"
                    data-bs-toggle="dropdown" aria-expanded="false">
              <i class="bi bi-currency-rupee"></i> INR
            </button>
            <div class="dropdown-menu currency-dropdown" aria-labelledby="currencyDropdown">
              <div class="currency-grid">
                <div class="currency-col">
                  <div class="currency-item">
                    <div class="currency-icon">₹</div>
                    <div class="currency-code">INR</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/in.png" alt=""></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-icon">AED</div>
                    <div class="currency-code">AED</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/ae.png" alt=""></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-icon">BD</div>
                    <div class="currency-code">BHD</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/bh.png" alt=""></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-icon">€</div>
                    <div class="currency-code">EUR</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/eu.png" alt=""></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-icon">£</div>
                    <div class="currency-code">GBP</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/gb.png" alt=""></div>
                  </div>
                </div>

                <div class="currency-col">
                  <div class="currency-item">
                    <div class="currency-icon">KWD</div>
                    <div class="currency-code">KWD</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/kw.png" alt=""></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-icon">ළ</div>
                    <div class="currency-code">LKR</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/lk.png" alt=""></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-icon">RM</div>
                    <div class="currency-code">MYR</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/my.png" alt=""></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-icon">OR</div>
                    <div class="currency-code">OMR</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/om.png" alt=""></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-icon">QAR</div>
                    <div class="currency-code">QAR</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/qa.png" alt=""></div>
                  </div>
                </div>

                <div class="currency-col">
                  <div class="currency-item">
                    <div class="currency-icon">SAR</div>
                    <div class="currency-code">SAR</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/sa.png" alt=""></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-icon">S$</div>
                    <div class="currency-code">SGD</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/sg.png" alt=""></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-icon">฿</div>
                    <div class="currency-code">THB</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/th.png" alt=""></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-icon">$</div>
                    <div class="currency-code">USD</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/us.png" alt=""></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-icon">R</div>
                    <div class="currency-code">ZAR</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/za.png" alt=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Language Dropdown -->
          <div class="dropdown">
            <button class="btn text-light btn-sm dropdown-toggle" type="button" id="countryDropdown"
                    data-bs-toggle="dropdown" aria-expanded="false">
              Language
            </button>
            <div class="dropdown-menu currency-dropdown country-dropdown" aria-labelledby="countryDropdown">
              <div class="currency-grid country-grid">
                <div class="currency-col">
                  <div class="currency-item">
                    <div class="currency-code country-code">English</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/us.png" alt="English"></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-code country-code">Français</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/fr.png" alt="Français"></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-code country-code">Español</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/es.png" alt="Español"></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-code country-code">Deutsch</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/de.png" alt="Deutsch"></div>
                  </div>
                </div>
                <div class="currency-col">
                  <div class="currency-item">
                    <div class="currency-code country-code">हिन्दी</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/in.png" alt="Hindi"></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-code country-code">العربية</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/ae.png" alt="Arabic"></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-code country-code">中文</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/cn.png" alt="Chinese"></div>
                  </div>
                  <div class="currency-item">
                    <div class="currency-code country-code">Русский</div>
                    <div class="currency-flag"><img src="https://flagcdn.com/w40/ru.png" alt="Russian"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Login / Signup - hidden on mobile -->
          <button class="btn btn-light text-dark btn-sm d-none d-lg-block" data-bs-toggle="modal"
                  data-bs-target="#loginModal">
            LOGIN / SIGNUP
          </button>
        </div>
      </nav>



    </div>



    <!-- Hero + Form -->
    <div class="container">
      <div class="row align-items-center justify-content-between">
        <!-- Hero Text Section -->
        <div class="col-md-6 hero-text text-white">


          <h1 class="banner-title text-white">
            The Smart Way to <br>
            <strong id="changing-text">
              <span> Grow Your <span class="highlight-word">Business</span></span>
            </strong>

          </h1>

          <p class="banner-subtext">
            <strong>A B2B Travel Portal Built Exclusively for Our Travel Partners.</strong>
            <!--Welcome to <strong>Ramdas Infotech</strong>, a premium platform built exclusively for travel agents and business to customer.<br>
            Simplify your workflow, maximize earnings, and deliver unmatched customer experiences.-->
          </p>


          <div class="d-flex flex-wrap align-items-center service-wrapper mb-3">
            <div class="service-box">
              <img src="./assets/images/Icon/flight-icon.png" alt="" width="40">
              <p>Flight</p>
            </div>
            <div class="service-box">
              <img src="./assets/images/Icon/hotel-icon.png" alt="" width="40">
              <p>Hotel</p>
            </div>
            <div class="service-box">
              <img src="./assets/images/Icon/holiday-icon.png" alt="" width="33px">
              <p>Holiday</p>
            </div>
            <div class="service-box">
              <img src="./assets/images/Icon/transfer-icon.png" alt="" width="40">
              <p>Transfer</p>
            </div>
          </div>
          <div class="d-flex flex-wrap align-items-center service-wrapper mb-3">
            <div class="service-box">
              <img src="./assets/images/Icon/car-icon.png" alt="" width="40">
              <p>Car</p>
            </div>
            <div class="service-box">
              <img src="./assets/images/Icon/cruise-icon.png" alt="" width="40">
              <p>Cruise</p>
            </div>
            <div class="service-box">
              <img src="./assets/images/Icon/transfer-icon.png" alt="" width="40">
              <p>Bus</p>
            </div>
            <div class="service-box">
              <img src="./assets/images/Icon/activity-icon.png" alt="" width="33">
              <p>Activity</p>
            </div>
          </div>
          <!-- <button class="register-btn">REGISTER NOW</button> -->

          <a routerLink="/register"><button class="btn btn-learn d-block mt-2 new-register-btn">REGISTER NOW</button></a>
        </div>


        <div class="col-md-4 offset-md-1 banner-form mt-md-0 ">
          <div class="login-card position-relative overflow-hidden">
            <h2>Log In</h2>
            <form (ngSubmit)="LoginUser(loginForm.form.valid)" #loginForm="ngForm" novalidate>
              <div class="mb-3">
                <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
                <input type="text" class="form-control" placeholder="Email"
                       [(ngModel)]="loginModel.UserRQ.RequestBody.UserDetails.UserName"
                       [ngClass]="{'is-invalid': loginForm.submitted && Email.invalid}" #Email="ngModel"
                       required name="Email">
              </div>
              <div class="mb-3">
                <label for="password" class="form-label">Password <span class="text-danger">*</span></label>
                <input type="password" class="form-control" placeholder="Password"
                       [(ngModel)]="loginModel.UserRQ.RequestBody.UserDetails.Password"
                       [ngClass]="{'is-invalid': loginForm.submitted && Password.invalid}"
                       #Password="ngModel" required name="Password">
              </div>
              <div class="mb-3 form-check">
                <input type="checkbox" class="form-check-input" id="rememberMe">
                <label class="form-check-label" for="rememberMe">Remember Me ?</label>
              </div>
              <button type="submit" hidden #loginbtn></button>
              <a href="javascript:void(0)" (click)="myFormSubmitHandler()" class="btn btn-submit">Submit</a>
            </form>
            <div class="forgot-password">
              Forgot your password? <a href="javascript:void(0);" (click)="ForgotPassword()">Reset Here</a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Wave shape at bottom -->
  <div class="wave-shape">
    <svg viewBox="0 0 500 150" preserveAspectRatio="none">
      <path d="M0.00,49.98 C150.00,150.00 349.76,-49.98 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
            style="stroke: none; fill: #f6f6f6;"></path>
    </svg>
  </div>
</section>
<!-- End Of Header Section -->
<!-- Login Modal -->
<div class="modal fade" id="loginModal" tabindex="-1" aria-labelledby="loginModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content p-0 border-0" style="border-radius: 20px; overflow: hidden;">
      <div class="d-flex flex-column flex-md-row w-100">
        <!-- Left Panel -->
        <div class="left-section">
          <div class="">
            <img src="https://images.emtcontent.com/emt-mate/content/assets/dist/images/freebooking.png"
                 alt="Signup Illustration">
            <h5>Easy Sign-Up Process</h5>
            <p>Sign up now and start the journey</p>
            <div class="dots">
              <div class="dot active"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </div>

        </div>

        <!-- Right Panel -->
        <div class="right-section">
          <h5 class="text-dark">Login or Create an account</h5>
          <input type="text" class="form-control mb-3" placeholder="Email ID or Mobile Number">
          <button class="btn continue-btn">Continue</button>
          <div class="terms">
            By logging in, I understand & agree to Ramdas Infotech
            <a href="#">terms of use</a> and <a href="#">privacy policy</a>
          </div>
          <div class="bank-details">
            <i class="bi bi-bank"></i>
            <a href="#" class="fw-semibold">Bank Details</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Of Login Modal -->
<!-- Hero Banner Wrapper Starts -->
<!-- <div class="container my-4">
  <div class="hero-banner-wrapper position-relative  overflow-hidden">
    <img src="https://gos3.ibcdn.com/myp_herodashboard_banner_dt-1711543049.png" alt="Become a myPartner Hero"
      class="img-fluid w-100 d-none d-md-block">
    <img src="https://gos3.ibcdn.com/myp_pwa_hero-1711539085.png" alt="Become a myPartner Hero"
      class="img-fluid w-100 d-block d-md-none">
  </div>
</div> -->
<!-- Hero Banner Wrapper Ends-->
<!-- Facilities Section Starts -->
<section class="facility-section">
  <div class="container">
    <div class="row g-3">
      <!-- Use Bootstrap grid gap -->
      <div class="col-12 col-md-4">
        <div class="facility-card">
          <img src="./assets/images/Icon/icons8-mobile-scrolling-100.png" alt="Icon">
          <div class="card-content-f">
            <div class="card-title">Easy Booking</div>
            <div class="card-text">We offer easy and convenient flight, hotel, holiday, transfer and more booking with attractive offers.</div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="facility-card">
          <img src="./assets/images/Icon/icons8-receive-dollar-100.png" alt="Icon">
          <div class="card-content-f">
            <div class="card-title">Lowest Price Guarantee</div>
            <div class="card-text">
              We ensure low rates on hotel reservations, holiday packages, and flight tickets.
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="facility-card">
          <img src="./assets/images/Icon/icons8-online-support-100.png" alt="Icon">
          <div class="card-content-f">
            <div class="card-title">24/7 Support</div>
            <div class="card-text">
              Get assistance 24×7 on any kind of travel-related query. We are happy to assist
              you.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Of Facility Section -->
<!-- Profitable Business Section Starts -->
<section class="container">
  <div class="why-choose-us py-5">
    <div class="row align-items-center">
      <!-- Left Column -->
      <div class="col-lg-6 mb-4 mb-lg-0">
        <div class="section-title premium-box p-4 mb-4">
          <p class="text-uppercase text-muted small fw-semibold mb-2">Why Choose Us</p>
          <h2 class="fw-bold text-new mb-3">Start Profitable B2B Travel Business</h2>
          <p class="text-muted mb-0">
            Ramdas Infotech is a leading B2B travel portal in India, offering top deals, smart technology, and
            financial growth opportunities.

          </p>
        </div>

        <div class="row gy-4">
          <!-- Item 1 -->
          <div class="col-sm-6 d-flex">
            <img src="./assets/images/Icon/icons8-receive-dollar-100.png" alt="Check" class="check-icon me-3">
            <div>
              <h6 class="fw-semibold mb-1">Best commission structure</h6>
              <p class="small text-muted mb-0">on all transactions and bookings</p>
            </div>
          </div>

          <!-- Item 2 -->
          <div class="col-sm-6 d-flex">
            <img src="./assets/images/Icon/icons8-training-100.png" alt="Check" class="check-icon me-3">
            <div>
              <h6 class="fw-semibold mb-1">Live training</h6>
              <p class="small text-muted mb-0">
                and assistance on products

              </p>
            </div>
          </div>

          <!-- Item 3 -->
          <div class="col-sm-6 d-flex">
            <img src="./assets/images/Icon/icons8-marketing-100.png" alt="Check" class="check-icon me-3">
            <div>
              <h6 class="fw-semibold mb-1">Regular Marketing</h6>
              <p class="small text-muted mb-0">and credit support to scale up your business</p>
            </div>
          </div>

          <!-- Item 4 -->
          <div class="col-sm-6 d-flex">
            <img src="./assets/images/Icon/icons8-online-support-100.png" alt="Check" class="check-icon me-3">
            <div>
              <h6 class="fw-semibold mb-1">24*7 Dedicated Support Center</h6>
              <p class="small text-muted mb-0">for resolving your query</p>
            </div>
          </div>

          <!-- Item 5 -->
          <div class="col-sm-6 d-flex">
            <img src="./assets/images/Icon/icons8-luggage-100.png" alt="Check" class="check-icon me-3">
            <div>
              <h6 class="fw-semibold mb-1">Wide Range of Offerings</h6>
              <p class="small text-muted mb-0">
                Including Flights, Cabs, Trains, Hotels, Cruises, Charters and Trains
              </p>
            </div>
          </div>

          <!-- Item 6 -->
          <div class="col-sm-6 d-flex">
            <img src="./assets/images/Icon/icons8-target-audience-100.png" alt="Check" class="check-icon me-3">
            <div>
              <h6 class="fw-semibold mb-1">Lead Generation</h6>
              <p class="small text-muted mb-0">for your market segment</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Column -->
      <div class="col-lg-6 position-relative">
        <img src="https://img.freepik.com/free-photo/guy-shows-document-girl-group-young-freelancers-office-have-conversation-working_146671-13569.jpg?ga=GA1.1.888798690.1690277295&semt=ais_items_boosted&w=740"
             class="img-fluid rounded shadow" alt="Office Team">
        <div class="info-box shadow-sm p-3 rounded position-absolute top-0 start-50 translate-middle-x translate-middle-y bg-white d-flex align-items-center">
          <i class="bi bi-person-vcard-fill text-new fs-4 me-2"></i>
          <span class="fw-semibold text-dark small">We’re Best Travel Company</span>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Of Profitable Business Section -->
<!-- Register Now Banner Section Starts -->
<section class="hotel-banner">
  <div class="container">
    <div class="row align-items-center">
      <!-- Left image -->
      <div class="col-md-4 text-center devices">
        <img src="./assets/images/system.png" alt="Mobile Devices" class="img-fluid" />
      </div>

      <!-- Right content -->
      <div class="col-md-8 text-white register-content">
        <h2>
          Start Today, Become Our Partner And Bring Your Business To<span class="highlight">New Heights</span>
        </h2>
        <p class="text-white">
          Websites developed by TravelLine display everything users look for.
          It is easy for travelers to pick and book rooms.
        </p>
        <a routerLink="/register" class="btn btn-learn">REGISTER NOW</a>
      </div>
    </div>
  </div>
</section>
<!-- End Of Register Now Banner Section -->
<!-- Acheivements Section Starts -->
<section class="container mt-5">
  <div class="achievement-section">
    <div class="row align-items-center">
      <!-- LEFT COLUMN -->
      <div class="col-lg-6">
        <p class="achievement-title mb-2">Achievement</p>
        <h2 class="main-heading mb-3">Your Destination Awaits, <span>Book Now</span></h2>
        <p class="text-muted mb-4">
          Lorem ipsum dolor sit amet consectetur. Sed leo sit semper sed facilisis ultrices
          urna eu. In tellus interdum vel ac massa interdum viverra elementum auctor.
        </p>

        <div class="row g-3 mb-4">
          <div class="col-md-6">
            <div class="stat-box">
              <div>
                <div class="stat-value">12870 +</div>
                <div class="stat-label">Happy Customers</div>
              </div>
              <i class="bi bi-person-circle"></i>
            </div>
          </div>
          <div class="col-md-6">
            <div class="stat-box">
              <div>
                <div class="stat-value">100 %</div>
                <div class="stat-label">Client Satisfied</div>
              </div>
              <i class="bi bi-person-circle"></i>
            </div>
          </div>
        </div>

        <div class="d-flex flex-wrap align-items-center gap-3">
          <span class="cta-text">Let's Connect Reach Out for More Information</span>
          <a routerLink="/Contactus"><button class="btn btn-contact">Contact us</button></a>
        </div>
      </div>

      <!-- RIGHT COLUMN -->
      <div class="col-lg-6 img-box mt-4 mt-lg-0">
        <img src="./assets/images/acheivement.jpg" alt="Passenger image">
      </div>
    </div>
  </div>
</section>
<!-- End Of Acheivement Section -->
<!-- Customer Need Section Starts -->
<section class="hotel-banner py-5 customer-needs">
  <div class="container">
    <h2 class="section-title mb-2">Everything Your Customer Needs!</h2>
    <p class="section-subtitle">Helping you find a perfect stay for everyone.</p>
    <div class="slick-slider slick-initialized">
      <div class="slick-list draggable">
        <div class="slick-track" style="opacity: 1; width: 1110px; transform: translate3d(0px, 0px, 0px);">
          <owl-carousel [options]="CustomOptions" [carouselClasses]="['row', 'owl-carousel']">
            <div class="slick-slide slick-current slick-active" data-slick-index="0" aria-hidden="false" tabindex="0" style="width: 185px;">
              <div class="card-wrapper">
                <img src="./assets/images/Icon/flights.jpg" alt="Flights">
                <div class="card-label">FLIGHTS</div>
              </div>
            </div>
            <div class="slick-slide slick-active" data-slick-index="1" aria-hidden="false" tabindex="0" style="width: 185px;">
              <div class="card-wrapper">
                <img src="./assets/images/Icon/hotels.jpg" alt="Hotels">
                <div class="card-label">HOTELS</div>
              </div>
            </div>
            <div class="slick-slide slick-active" data-slick-index="2" aria-hidden="false" tabindex="0" style="width: 185px;">
              <div class="card-wrapper">
                <img src="./assets/images/Icon/holidays.jpg" alt="Holidays">
                <div class="card-label">HOLIDAYS</div>
              </div>
            </div>
            <div class="slick-slide slick-active" data-slick-index="3" aria-hidden="false" tabindex="0" style="width: 185px;">
              <div class="card-wrapper">
                <img src="./assets/images/Icon/sightseeing.jpg" alt="Sightseeing">
                <div class="card-label">SIGHTSEEING</div>
              </div>
            </div><div class="slick-slide slick-active" data-slick-index="4" aria-hidden="false" tabindex="0" style="width: 185px;">
              <div class="card-wrapper">
                <img src="./assets/images/Icon/cruise.jpg" alt="Cruise">
                <div class="card-label">CRUISE</div>
              </div>
            </div><div class="slick-slide slick-active" data-slick-index="5" aria-hidden="false" tabindex="0" style="width: 185px;">
              <div class="card-wrapper">
                <img src="./assets/images/Icon/cab.jpg" alt="Flights">
                <div class="card-label">CAB</div>
              </div>
            </div>
          </owl-carousel>
        </div>
      </div>
    </div>

    <div class="cta-text-new mt-4">
      Don’t wait, start growing your business<br class="d-md-none" /> with Ramdas
      Infotech today!
    </div>
    <a routerLink="/Contactus"><button class="btn btn-learn d-block mt-2" style="margin: auto;">CONTACT US</button></a>
  </div>
</section>
<!--<main>
  <section class="airlines">
    <h2>Recommended International Destinations</h2>
    <p class="pop-p">Book Top rated and best in class hotels</p> <span class="bar"></span>
    <div class="pop-mt"></div>
    <div class="container">
      <owl-carousel [options]="CustomOptions1" [carouselClasses]="['air-img', 'owl-carousel','sliding']">
        <div> <img width="400" src="assets/images/hotel/ibis-logo.svg"> </div>
        <div> <img width="400" src="assets/images/hotel/novotel-logo.svg"> </div>
        <div> <img width="400" src="assets/images/hotel/sheraton-logo.svg"> </div>
        <div> <img width="400" src="assets/images/hotel/choice-logo.svg"> </div>
        <div> <img width="400" src="assets/images/hotel/hyatt-logo.svg"> </div>
        <div> <img width="400" src="assets/images/hotel/whotels-logo.svg"> </div>
        <div> <img src="assets/images/hotel/ihg-logo.svg"> </div>
        <div> <img src="assets/images/hotel/crowneplaza-logo.svg"> </div>
        <div> <img src="assets/images/hotel/intercontinental-logo.svg"> </div>
        <div> <img src="assets/images/hotel/kempinski-logo.svg"> </div>
        <div> <img src="assets/images/hotel/swissotel-logo.svg"> </div>
        <div> <img src="assets/images/hotel/accor-logo.svg"> </div>
      </owl-carousel>
    </div>
  </section>
  </main>-->
<!-- End Of Customer Need Section -->
<!-- Top Airline Section Starts -->
<section class="container mt-5">
  <div class="achievement-section airlines-section">
    <h2 class="text-center">Exclusive Deals & Special Fares On Top International Airlines</h2>
    <div class="row g-3 g-md-4 justify-content-center">
      <div class="col-4 col-sm-3 col-md-2">
        <div class="airline-logo">
          <img src="./assets/images/Icon/Air_India-Logo.wine-removebg-preview.png" alt="British Airways">
        </div>
      </div>
      <div class="col-4 col-sm-3 col-md-2">
        <div class="airline-logo">
          <img src="./assets/images/Icon/British_Airways-Logo.wine.png" alt="Lufthansa">
        </div>
      </div>
      <div class="col-4 col-sm-3 col-md-2">
        <div class="airline-logo">
          <img src="./assets/images/Icon/cathay-pacific-removebg-preview.png" alt="ITA Airways">
        </div>
      </div>
      <div class="col-4 col-sm-3 col-md-2">
        <div class="airline-logo">
          <img src="./assets/images/Icon/emirates.png" alt="Generic">
        </div>
      </div>
      <div class="col-4 col-sm-3 col-md-2">
        <div class="airline-logo">
          <img src="./assets/images/Icon/Gulf-Air-logo-removebg-preview.png" alt="Air France">
        </div>
      </div>
      <div class="col-4 col-sm-3 col-md-2">
        <div class="airline-logo">
          <img src="./assets/images/Icon/indigo-logo.png" alt="KLM">
        </div>
      </div>
      <div class="col-4 col-sm-3 col-md-2">
        <div class="airline-logo">
          <img src="./assets/images/Icon/png-clipart-airasia-logo-product-brand-airbus-a320-family-airline-logo-text-logo-removebg-preview.png"
               alt="Delta">
        </div>
      </div>

      <!-- Next Row -->
      <div class="col-4 col-sm-3 col-md-2">
        <div class="airline-logo">
          <img src="./assets/images/Icon/qatar.png" alt="Oman Air">
        </div>
      </div>
      <div class="col-4 col-sm-3 col-md-2">
        <div class="airline-logo">
          <img src="./assets/images/Icon/singapore.png" alt="Turkish Airlines">
        </div>
      </div>
      <div class="col-4 col-sm-3 col-md-2">
        <div class="airline-logo">
          <img src="./assets/images/Icon/cathay-pacific-removebg-preview.png" alt="ITA Airways">
        </div>
      </div>
      <div class="col-4 col-sm-3 col-md-2">
        <div class="airline-logo">
          <img src="./assets/images/Icon/emirates.png" alt="Generic">
        </div>
      </div>
      <div class="col-4 col-sm-3 col-md-2">
        <div class="airline-logo">
          <img src="./assets/images/Icon/Gulf-Air-logo-removebg-preview.png" alt="Air France">
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Of Top Airline Section -->
<!-- FOoter Section Starts -->
<footer class="footer">
  <div class="container">
    <div class="d-flex flex-wrap justify-content-between align-items-center footer-flex">
      <div>
        Copyright © {{currentYear}} Ramdas Infotech. All rights reserved.
      </div>
      <div class="d-flex flex-wrap justify-content-center">
        <a routerLink="/aboutus">About Us</a><span class="footer-divider">|</span>
        <a routerLink="/Faq">Help/FAQs</a><span class="footer-divider">|</span>
        <a routerLink="/Termandcondition">Terms Of Conditions</a><span class="footer-divider">|</span>
        <a routerLink="/Contactus">Contact Us</a>
      </div>
    </div>
  </div>
</footer>
<app-loader *ngIf="loader"></app-loader>

<div style="width:80% !important;">
  <ng-template #ModalPopup>
    <!--Forgot Password-->
    <div class="modal-header">
      <h2 class="modal-title pull-left">Forgot Password</h2>
      <button type="button" class="close pull-right" style="background: none;" aria-label="Close"
              (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div>
      <div class="login-head modal-body">
        <h4>Reset Your Password</h4>
        <p>Already have an account? <a class="link-color-m" href="javascript:void(0);" (click)="this.modalRef.hide()">Log In</a></p>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12 b-r">
            <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
              <div class="form-group">
                <input #inp formControlName="username" type="text" class="form-control"
                       placeholder="Username" name="Username"
                       [(ngModel)]="forgotModel.UserRQ.RequestBody.UserDetails.UserName"
                       [class.is-invalid]="form.get('username')?.invalid && form.get('username')?.touched">
                <div *ngIf="form.controls['username'].errors && form.controls['username'].touched"
                     class="error">
                  <div *ngIf="form.controls['username'].errors['required']"></div>
                </div>
              </div>
              <div class="form-group">
                <input formControlName="email" type="email" class="form-control" placeholder="Email"
                       name="Email"
                       [class.is-invalid]="form.get('email')?.invalid && form.get('email')?.touched"
                       [(ngModel)]="forgotModel.UserRQ.RequestBody.UserDetails.Email">
                <div *ngIf="form.controls['email'].invalid && form.controls['email'].touched"
                     class="error">
                  <div *ngIf="form.controls['email'].errors['required']" class="error"></div>
                  <div *ngIf="form.controls['email'].errors['email']" class="error "></div>
                </div>
                <p class="text-danger mt-2">{{msg}}</p>
              </div>
              <br />
              <button type="submit" class="btn continue-btn">
                Submit
              </button>
            </form>

          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
